// extracted by mini-css-extract-plugin
export default {"title":"HeroTitle_title__hDtCp","nowSvg":"HeroTitle_nowSvg__me5hy"};